
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import global from '../../../static/js/global.js'
export default {
components: {
Group,
XInput,
Tab,
TabItem
},
data(){
return {
bgimg:'',
keyword:''
}
},
beforeMount(){
this.bgimg = global.imgUrl + '/image/bg.jpg';
console.log(this.bgimg)
},
methods:{
onItemClick(index){
if(index == 1){
this.$router.push({path:'/convenientDetail/favorite',query:{communityId:communityId,moduleId:this.$router.history.current.query.moduleId,serverId:this.$router.history.current.query.serverId}})
}else{
this.$router.push({path:'/convenientDetail/all',query:{communityId:communityId,moduleId:this.$router.history.current.query.moduleId,serverId:this.$router.history.current.query.serverId}})
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/convenientComponents/convenientDetail.vue